import React from "react";
import { t } from "i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import AdvancedLazyImage from "./AdvancedLazyImage";
const Products = () => {
  const products = [
    {
      id: 1,
      name: t("fertilizers"),
      image: "img/Products/product-2.png",
      description: t("fertilizers_description"),
    },
    {
      id: 2,
      name: t("seeds"),
      image: "img/Products/product-4.png",
      description: t("seeds_description"),
    },
    {
      id: 3,
      name: t("agricultural_supplies"),
      image: "img/Products/product-3.png",
      description: t("supplies_description"),
    },
  ];

  return (
    <div className="container-fluid product py-5 my-5">
      <div className="container py-5">
        {/* العنوان */}
        <div
          className="section-title text-center mx-auto wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "500px" }}
        >
          <p className="fs-5 fw-medium fst-italic text-primary">
            {t("our_products")}
          </p>
          <h1 className="display-6">{t("products_heading")}</h1>
        </div>

        {/* مكون Swiper */}
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          breakpoints={{
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
          style={{ paddingBottom: "40px" }}
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <div className="p-3">
                <div className="d-block product-item rounded">
                  <AdvancedLazyImage
                    src={product.image}
                    alt={product.name}
                    imgclassName="w-100 rounded"
                  />
                  <div className="bg-white shadow-sm text-center p-4 position-relative mt-n5 mx-4">
                    <h4 className="text-primary">{product.name}</h4>
                    <span className="text-body">{product.description}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Products;
